(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-template-lp"]) return;
  try {
    
      $(function () {
        $(".visible").on("inview", function (event, isInView) {
          if (isInView) {
            $(this).addClass("effect");
          } else {
            $(this).removeClass("effect");
          }
          //$('#footer').off('inview');
        });
      });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-catalogue-template"]) return;
  try {
    
      $(function () {
        $(".visible").on("inview", function (event, isInView) {
          if (isInView) {
            $(this).addClass("effect");
          } else {
            $(this).removeClass("effect");
          }
          //$('#footer').off('inview');
        });
      });
  
  $(function () {
  // スクロールしたらトップに戻るボタン
  const toTopButton = $(".js-to-top");
  const scrollHeight = 200;
  toTopButton.hide();
  $(window).scroll(function () {
    if ($(this).scrollTop() > 200) {
      toTopButton.fadeIn();
    } else {
      toTopButton.fadeOut();
    }
  });

  // 「トップに戻る」ボタンをクリックしたらスクロールで戻る
  toTopButton.click(function () {
    $("body,html").animate({ scrollTop: 0 }, 800);
    return false;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-spring23-template"]) return;
  try {
    
      $(function () {
        $(".visible").on("inview", function (event, isInView) {
          if (isInView) {
            $(this).addClass("effect");
          } else {
            $(this).removeClass("effect");
          }
          //$('#footer').off('inview');
        });
      });
  
  $(function () {
  // スクロールしたらトップに戻るボタン
  const toTopButton = $(".js-to-top");
  const scrollHeight = 200;
  toTopButton.hide();
  $(window).scroll(function () {
    if ($(this).scrollTop() > 200) {
      toTopButton.fadeIn();
    } else {
      toTopButton.fadeOut();
    }
  });

  // 「トップに戻る」ボタンをクリックしたらスクロールで戻る
  toTopButton.click(function () {
    $("body,html").animate({ scrollTop: 0 }, 800);
    return false;
  });
});

  } catch(e) { console.error(e); }
})();
})();
